<template>
  <main class="main" v-if="exhibition">
    <div class="page-title">
      {{ exhibition.title }}
    </div>
    <div
      v-if="exhibition.images.length > 0"
      class="larkin-gallery"
      ref="gallery"
      :style="{ height: slideHeight + 'px' }"
    >
      <div
        class="larkin-slide"
        @mousemove="arrows"
        ref="slide"
        v-bind:class="{ active: activeIndex == index }"
        v-for="(image, index) in exhibition.images"
        :key="index"
      >
        <img
          class="slide"
          @click="changeSlide(index, $event)"
          :style="{ height: slideHeight + 'px' }"
          :src="image.thumb"
          :srcset="image.srcset"
          :alt="image.caption"
        />
        <div class="slide-info">
          <div class="slide-caption" v-html="image.caption"></div>
          <div class="slide-counter">
            {{ index + 1 }}/{{ exhibition.images.length }}
          </div>
        </div>
      </div>
    </div>
    <div class="page-text" v-html="exhibition.text" />
    <div class="page-text">
      <a
        v-for="file in exhibition.document"
        :key="file.url"
        :href="file.url"
        target="_blank"
      >
        {{ file.caption }}
      </a>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "exhibition",
  metaInfo() {
    return {
      title: "- " + this.exhibition.title,
    };
  },
  computed: mapState(["exhibition"]),
  data() {
    return {
      slideHeight: null,
      activeIndex: 0,
    };
  },
  created() {
    window.addEventListener("resize", this.calcHeight, true);
  },
  destroyed() {
    window.removeEventListener("resize", this.calcHeight, true);
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    arrows(event) {
      if (event.target.clientWidth / 2 > event.layerX) {
        this.$refs.gallery.classList.add("prev");
        this.$refs.gallery.classList.remove("next");
      } else {
        this.$refs.gallery.classList.remove("prev");
        this.$refs.gallery.classList.add("next");
      }
    },
    calcHeight() {
      this.slideHeight = this.$refs.gallery.clientWidth / 1.5;
    },
    changeSlide(index, $event) {
      if ($event.target.clientWidth / 2 > $event.layerX) {
        if (index + 1 === 1) {
          this.activeIndex = this.$refs.slide.length - 1;
        } else {
          this.activeIndex = index - 1;
        }
      } else {
        if (this.$refs.slide.length === index + 1) {
          this.activeIndex = 0;
        } else {
          this.activeIndex = index + 1;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/defaults.scss";

span {
  display: inline-block;
  width: 3 * $gap;
}
.page-title {
  margin-bottom: $gap / 6;
}
.larkin-gallery {
  position: relative;
  display: block;
  width: 100%;
  height: 67%;
  margin-bottom: $gap * 3;
  @media only screen and (max-width: $phone) {
    margin-bottom: $gap * 6;
  }
  &.next {
    .larkin-slide {
      img {
        cursor: e-resize;
      }
    }
  }
  &.prev {
    .larkin-slide {
      img {
        cursor: w-resize;
      }
    }
  }
  .larkin-slide {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin-right: $gap;
    position: absolute;
    display: none;
    &.active {
      display: block;
    }
    img {
      width: 100%;
      object-fit: contain;
      object-position: top left;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      user-select: none;
    }
    .slide-info {
      margin-top: ($line-height * $font-size) / 6;
      font-size: $font-size / 1.75;
      margin-bottom: $gap;
      width: 100%;
      .slide-caption {
        display: inline-block;
        width: 75%;
      }
      .slide-counter {
        display: inline-block;
        text-align: right;
        width: 25%;
        vertical-align: top;
      }
    }
  }
}
</style>
